import { render, staticRenderFns } from "./contract-versions.component.vue?vue&type=template&id=1fae38c8"
import script from "./contract-versions.component.vue?vue&type=script&lang=ts"
export * from "./contract-versions.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports